import React from 'react';
import PropTypes from 'prop-types';
import RequestHeaders from './RequestHeaders';
import RequestBody from './RequestBody';
import base64Decoder, { base64DecodePretty } from 'app/shared/decoders/base64Decoder';

export default function DebuggerDrawerRequestContent({ requestHeaders, requestBody }) {
  const decodedHeaders = base64Decoder(requestHeaders);
  const formattedBody = base64DecodePretty({ encodedData: requestBody, lang: 'json' });

  return (
    <>
      <RequestHeaders value={decodedHeaders} />

      {formattedBody && <RequestBody value={formattedBody} />}
    </>
  );
}

DebuggerDrawerRequestContent.propTypes = {
  requestHeaders: PropTypes.string.isRequired,
  requestBody: PropTypes.string.isRequired,
};
